export default __webpack_public_path__ + "static/media/logo.273515a5.svg";